module.exports = __webpack_public_path__ + "img/776045_D2CCC3_281910_BBB5AA-256px.14bbca3c.png";